import SiBarcode from '@/icons/SiBarcode';
import SiBox from '@/icons/SiBox';
import SiCode from '@/icons/SiCode';
import SiCommand from '@/icons/SiCommand';
import SiContract from '@/icons/SiContract';
import SiDevices from '@/icons/SiDevices';
import SiDimensions from '@/icons/SiDimensions';
import SiDoc from '@/icons/SiDoc';
import SiGaming from '@/icons/SiGaming';
import SiHardDriveStorage from '@/icons/SiHardDriveStorage';
import SiInformation from '@/icons/SiInformation';
import SiLightning from '@/icons/SiLightning';
import SiMicrochip from '@/icons/SiMicrochip';
import SiMonitor from '@/icons/SiMonitor';
import SiPackage from '@/icons/SiPackage';
import SiPen from '@/icons/SiPen';
import SiPlug from '@/icons/SiPlug';
import SiPlugIn from '@/icons/SiPlugIn';
import SiSdCard from '@/icons/SiSdCard';
import SiServer from '@/icons/SiServer';
import SiShipment from '@/icons/SiShipment';
import SiSmartphone from '@/icons/SiSmartphone';
import SiSticker from '@/icons/SiSticker';
import SiTablet from '@/icons/SiTablet';
import SiTag from '@/icons/SiTag';
import SiUsb from '@/icons/SiUsb';
import SiVideoCamera from '@/icons/SiVideoCamera';
import SiWrench from '@/icons/SiWrench';
import { ReactNode } from 'react';

const icons: Record<string, ReactNode> = {
  screen: <SiMonitor />,
  cpu: <SiMicrochip />,
  gpu: <SiGaming />,
  storage: <SiHardDriveStorage />,
  os: <SiCommand />,
  smartphone: <SiSmartphone />,
  memory: <SiSdCard />,
  cable: <SiPlug />,
  connector: <SiUsb />,
  size: <SiDimensions />,
  software: <SiCode />,
  contract: <SiContract />,
  shipment: <SiShipment />,
  box: <SiBox />,
  package: <SiPackage />,
  label: <SiSticker />,
  tag: <SiTag />,
  service: <SiWrench />,
  server: <SiServer />,
  devices: <SiDevices />,
  document: <SiDoc />,
  webcam: <SiVideoCamera />,
  dock: <SiPlugIn />,
  tablet: <SiTablet />,
  stylus: <SiPen />,
  power: <SiLightning />,
  lightning: <SiLightning />,
  barcode: <SiBarcode />
};

// This is a slightly odd pattern in that we're using a Proxy to provide
// custom logic on how to handle icons that aren't found in the icons object
// or use a different name. Here we're able to transparently handle the
// different names for the same icon without having to define multiple entries.
export const SpecIcons = new Proxy(icons, {
  get: function (target, name) {
    if (typeof name === 'symbol') throw new Error('Symbol not supported');
    const id = name.toLowerCase();
    const icon = target[id];
    // If we have an icon, return it
    if (icon) return icon;

    // Otherwise, try to find an icon that matches the name
    switch (id) {
      case 'chip':
        return <SiMicrochip />;
      case 'gaming':
        return <SiGaming />;
      case 'command':
        return <SiCommand />;
      default:
        return <SiInformation />;
    }
  }
});
